export const kitchen = [
  "Газовая плита",
  "Духовка",
  "Кофеварка",
  "Микроволновая печь",
  "Посуда",
  "Посудомоечная машина",
];

export const games = [
  "Компьютер",
  "Игровая приставка",
  "Настольный тенис",
  "Бильярд",
  "Детская игровая комната",
];
